import React from 'react';
export var IconHOC = function (_a) {
    var paths = _a.paths, viewBox = _a.viewBox;
    return function (Component) { return function (_a) {
        var colorType = _a.colorType, size = _a.size;
        return (React.createElement(Component, { colorType: colorType, paths: paths, size: size, viewBox: viewBox }));
    }; };
};
